// removed by extract-text-webpack-plugin
module.exports = {"icon":"_1D3uMMajg9LYVPWOz9KeKw","profileItemWrapper":"_3GrBB1tgj3nOXwa734mJgU","textWrapper":"_24V_OTK-YH1AzAUbUay-j4"};


//////////////////
// WEBPACK FOOTER
// ./src/layout/Dashboard/Header/ProfileDisplay/ProfileItem/style.css
// module id = 1873
// module chunks = 0